"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var ReactIs = _interopRequireWildcard(require("react-is"));

var _Menu = _interopRequireDefault(require("@material-ui/core/Menu"));

var _withThemeProps = _interopRequireDefault(require("../withThemeProps"));

/**
 * Base implementation of "any thing", basicly button with drop down menu.
 *
 * Pokud dostane `icon` vysledkem je IconButton. V opacnem pripade se vyrenderuje Button.
 *
 * > Ostatni props budou predany do buttonu.
 *
 * @component
 */
var ButtonWithMenu = function ButtonWithMenu(_ref) {
  var children = _ref.children,
      componentJoinId = _ref.id,
      menuItems = _ref.menuItems,
      MenuProps = _ref.MenuProps;

  var _React$useRef = _react.default.useRef(Math.random().toString()),
      randomId = _React$useRef.current;

  var _React$useState = _react.default.useState({
    open: false,
    anchorEl: null
  }),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      _React$useState2$ = _React$useState2[0],
      anchorEl = _React$useState2$.anchorEl,
      open = _React$useState2$.open,
      setState = _React$useState2[1];

  var handleOpenMenu = _react.default.useCallback(function (event) {
    setState({
      open: true,
      anchorEl: event.currentTarget
    });
  }, []);

  var handleRequestClose = _react.default.useCallback(function () {
    setState({
      open: false,
      anchorEl: null
    });
  }, []);

  var id = componentJoinId || randomId;

  var items = _react.default.useMemo(function () {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var wrapItemClickHandler = function wrapItemClickHandler(parentFnc) {
      return function () {
        handleRequestClose();

        if (parentFnc) {
          parentFnc.apply(void 0, arguments);
        }
      };
    };

    var xitems = ReactIs.isFragment(menuItems) ? menuItems.props.children : menuItems;
    return _react.default.Children.map(xitems, function (child) {
      if (child && child.type) {
        var onClick = wrapItemClickHandler(child.props.onClick);
        var props = (0, _extends2.default)({}, child.props, {
          onClick: onClick
        });
        return /*#__PURE__*/_react.default.cloneElement(child, props);
      }

      return child;
    });
  }, [handleRequestClose, menuItems]);

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children({
    id: id,
    onClick: handleOpenMenu
  }), /*#__PURE__*/_react.default.createElement(_Menu.default, (0, _extends2.default)({
    id: id,
    anchorEl: anchorEl,
    open: open,
    onClose: handleRequestClose,
    anchorOrigin: {
      horizontal: 'left',
      vertical: 'top'
    },
    getContentAnchorEl: null
  }, MenuProps), items));
};

process.env.NODE_ENV !== "production" ? ButtonWithMenu.propTypes = {
  children: _propTypes.default.func.isRequired,
  id: _propTypes.default.string,
  menuItems: _propTypes.default.element.isRequired
} : void 0;
ButtonWithMenu.displayName = 'ButtonWithMenu';

var _default = (0, _withThemeProps.default)({
  name: 'SxButtonWithMenu'
})(ButtonWithMenu);

exports.default = _default;